<template>
    <div :class="['loader-wrapper', { 'hide-loader': !isVisible }]">
      <div class="loader-icon">
        <img src="@/assets/img/home/loading.gif" alt="loader" />
      </div>
    </div>
  </template>

<script>
export default {
    name: "Loader",
    props: {
        isVisible: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style scoped>
.loader-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100dvh;
    background-color: black;
    background-image: url(@/assets/img/home/star-sky-night.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 102;
    opacity: 1;
    transition: opacity 1s ease-out;
}

.loader-wrapper.hide-loader {
    opacity: 0;
    pointer-events: none;
}

.loader-icon {
    position: fixed;
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    opacity: 0.5;
}

.loader-icon img {
    width: 30px;
    height: 30px;
    object-fit: cover;
}
</style>